/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.5.3 public/grass.glb -o src/models/plants/Grass.jsx --transform --draco 
Files: public/grass.glb [4.83MB] > /Users/radek/Documents/GIthub/CoffeeCoded/coffeecoded/src/models/plants/assets/plants/grass-transformed.glb [236.94KB] (95%)
*/

import React from 'react'
import { useGLTF } from '@react-three/drei'
import modelUrl from '../../assets/plants/grass-transformed.glb'

export function Model(props) {
  const { nodes, materials } = useGLTF(modelUrl)
  return (
    <group {...props} dispose={null}>
      <mesh geometry={nodes.Plant_05.geometry} material={materials.Vegetation} rotation={[Math.PI / 2, 0, 0]} scale={0.01} />
    </group>
  )
}

useGLTF.preload(modelUrl)
